{
  "hero": {
    "subtitle": "Live Practice · 24/7",
    "headline": "A social platform uniting people",
    "headlineHighlight": "on the path to growth.",
    "tagline": "Masters, live practices, retreats, AI assistant, personal calendar and a community that supports your evolution. Online and offline, anywhere in the world.",
    "stat1Num": "Live Sessions",
    "stat1Label": "With masters 24/7",
    "stat2Num": "Community",
    "stat2Label": "Your people, nearby",
    "stat3Num": "Events",
    "stat3Label": "Worldwide",
    "valueProp1": "Practice live with real masters",
    "valueProp2": "24/7 · Always on",
    "valueProp3": "AI-guided, personally matched",
    "startPractice": "Begin Practice",
    "exploreSchedule": "Explore Schedule",
    "backLink": "← Back",
    "joinLiveNow": "Join Live Now",
    "viewProfile": "View profile →",
    "viewProfileNative": "View Profile",
    "description": "A social platform for those who practice. World-class masters, live and recorded sessions, online and offline events, and a community that shares your path."
  },
  "agapeBanner": {
    "overline": "OPEN PRACTICE",
    "titleBefore": "The ",
    "titleHighlight": "Agapē",
    "titleAfter": " Practice",
    "subheadline": "15 minutes to return to yourself. Stillness, clarity, and total reset.",
    "ctaJoin": "I Want!",
    "ctaJoined": "YOU'RE IN",
    "inviteFriends": "Invite Friends",
    "linkCopied": "Link copied!",
    "shareMessage": "Join me for the Agapē Practice this Sunday"
  },
  "onboarding": {
    "focusTitle": "What is your focus?",
    "goalTitle": "Your primary goal?",
    "timeTitle": "Preferred time?",
    "focusTitleShort": "Focus?",
    "goalTitleShort": "Goal?",
    "timeTitleShort": "When?",
    "meditation": "Meditation",
    "yoga": "Yoga",
    "breathing": "Breathing",
    "focus": "Focus",
    "relaxation": "Relaxation",
    "wellbeing": "Well-being",
    "clarity": "Clarity",
    "energy": "Energy",
    "sleep": "Sleep",
    "morning": "Morning",
    "afternoon": "Afternoon",
    "evening": "Evening",
    "night": "Night",
    "recorded": "Recorded",
    "live": "Live sessions",
    "next": "NEXT",
    "finish": "FINISH",
    "back": "BACK"
  },
  "startingSoon": {
    "featuresTitleBefore": "",
    "featuresTitleAfter": " Features",
    "overline": "Practice Together",
    "title": "Live sessions right now",
    "subtitle": "Join online practices with our best guides in real-time.",
    "joinNow": "JOIN NOW",
    "joinNowBtn": "Join",
    "noSessions": "No upcoming sessions right now.",
    "exploreSchedule": "EXPLORE SCHEDULE",
    "capabilitiesTitle": "Agapēlla Features",
    "capabilitiesSubtitle": "No live sessions right now — explore the platform",
    "capabilitiesHint": "Everything you need for your practice — in one space",
    "openCard": "Open",
    "features": {
      "createRoomTitle": "Create your own live session",
      "createRoomTagline": "Pick a practice, invite friends — and practice together live",
      "findMasterTitle": "Find your master",
      "findMasterTagline": "Experts in meditation, psychology, and philosophy — your personal guide",
      "findCircleTitle": "Find your circle",
      "findCircleTagline": "Like-minded people, shared practices and community events every day",
      "talkAgapellaTitle": "Talk to Agapella",
      "talkAgapellaTagline": "AI assistant tailors a practice to your mood and builds a program for you",
      "calendarTitle": "Events calendar",
      "calendarTagline": "Online and offline events by interest. Agapella reminds you ahead of time",
      "libraryTitle": "Practice library",
      "libraryTagline": "Meditation, breathwork, psychology, philosophy — find the practice that fits you"
    }
  },
  "dailyRhythm": {
    "liveBadge": "LIVE",
    "liveNow": "LIVE",
    "min": "min",
    "joinNowBtn": "Join now",
    "imGoing": "I'm going",
    "join": "Join",
    "noFilterThisDay": "No {{label}} this day",
    "noMatchingEvents": "No matching events",
    "otherEvents": "other events ↓",
    "emptyMyTitle": "You have no scheduled events",
    "emptyTitle": "No events scheduled",
    "emptyMyDesc": "You have no events planned for this day.",
    "emptyDesc": "Your schedule for this day is clear.",
    "selectFromSchedule": "Select from schedule",
    "title": "Your Practice.",
    "titleHighlight": "Every Day.",
    "subtitle": "Plan your journey. Select a day to view the schedule.",
    "fullCalendar": "FULL CALENDAR",
    "allTraditions": "All Traditions",
    "tradition": "TRADITION",
    "featured": "FEATURED",
    "agape": "AGAPÉ",
    "saveSpot": "Save your spot",
    "lives": "Live sessions",
    "events": "Events",
    "loading": "Loading schedule...",
    "loadFailed": "Couldn't load schedule",
    "noSessions": "No sessions scheduled for {{day}}.",
    "today": "Today",
    "withMaster": "with {{name}}",
    "reminderSet": "Reminder set",
    "reminderRemoved": "Reminder removed",
    "reminderFailed": "Failed to update reminder",
    "signUpNotify": "Sign up to get notified about this session",
    "signUpSaveSpot": "Sign up to save your spot for this session",
    "myCalendar": "My Calendar",
    "filters": {
      "paths": "Paths",
      "livestreams": "Livestreams",
      "livePractice": "Live Practice",
      "offline": "Offline",
      "all": "All",
      "selectPath": "SELECT A PATH:"
    },
    "paths": {
      "meditation": "Meditation",
      "psychology": "Psychology",
      "philosophy": "Philosophy",
      "body": "Body Practices",
      "breathwork": "Breathwork",
      "morning": "Morning Practice",
      "sleep": "Before Sleep",
      "traditions": "Traditions"
    },
    "formats": {
      "offline": "OFFLINE",
      "online": "ONLINE",
      "livestream": "LIVESTREAM",
      "liveroom": "LIVE PRACTICE"
    },
    "monthNames": [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "dayNames": [
      "Sun",
      "Mon",
      "Tue",
      "Wed",
      "Thu",
      "Fri",
      "Sat"
    ]
  },
  "videoBlock": {
    "overline": "The Platform",
    "title": "This is",
    "titleHighlight": "Agapé",
    "headlineHighlight": "uniting.",
    "tagline": "A new-format social platform for practitioners. Masters, live sessions, community and events — all in one space.",
    "stat1Num": "Live Practices",
    "stat1Label": "Live sessions with masters 24/7",
    "stat2Num": "Your Circle",
    "stat2Label": "A community of kindred spirits",
    "stat3Num": "Online & Offline",
    "stat3Label": "Events near you",
    "description": "Agapēlla is an environment that moves you forward. Find masters and people with whom growth becomes natural."
  },
  "communityJoin": {
    "badge": "Mobile App",
    "title": "Join the",
    "titleHighlight": "Agapē Community",
    "description": "Practice anywhere. Offline meditations, progress tracking, and direct access to masters — always at your fingertips.",
    "appStoreLabel": "Download on the",
    "appStoreName": "App Store",
    "playStoreLabel": "GET IT ON",
    "playStoreName": "Google Play",
    "rating": "4.9/5 from 2,000+ members"
  },
  "communityFeed": {
    "sectionLabel": "Community",
    "postsFrom": "Posts from the Master",
    "you": "You",
    "pinned": "Pinned by master",
    "firstComment": "Be the first to comment",
    "addComment": "Add a comment...",
    "sharePlaceholder": "Share something with your community...",
    "newPost": "New Post",
    "whatOnMind": "What's on your mind?",
    "audienceLabel": "Audience",
    "audiencePublic": "For everyone",
    "audienceSubscribers": "For subscribers",
    "postLockedTitle": "This post is for the master's subscribers",
    "postLockedBody": "Subscribe to {{name}} to read it",
    "postLockedMaster": "the master",
    "postLockedCta": "Subscribe to the master",
    "postLockedSignIn": "Sign in to subscribe to the master and read the post.",
    "postGone": "This post is unavailable: it was deleted or hidden.",
    "postLoadFailed": "Couldn't open the post.",
    "noPostsGuest": "No posts yet",
    "noPostsOwner": "No posts yet — share your first post above!",
    "post": "POST",
    "addPhoto": "Add photo",
    "addVideo": "Add video",
    "photoAttached": "Photo attached",
    "removePhoto": "Remove photo",
    "photoLabel": "Photo",
    "videoLabel": "Video",
    "uploadingVideo": "Uploading… {{percent}}%",
    "processingVideo": "Processing video…",
    "currentVideo": "Current video",
    "tooManyPhotos": "You can attach at most {{count}} photos to a post",
    "photosOrVideo": "A post can carry either photos or a video — not both",
    "eventChip": "EVENT",
    "onlineAnnouncementChip": "Online session announcement",
    "offlineEventChip": "Offline event",
    "practiceChip": "PRACTICE",
    "goTo": "Open",
    "join": "Join",
    "joined": "Going",
    "pin": "Pin",
    "unpin": "Unpin",
    "delete": "Delete",
    "deleteConfirmTitle": "Delete the post?",
    "deleteConfirmBody": "It will disappear for every member of the community. This cannot be undone.",
    "deleteConfirmBodyDiscussion": "The post and its discussion will disappear for every participant, messages included. This cannot be undone.",
    "edit": "Edit",
    "edited": "Edited",
    "readMore": "Read more",
    "close": "Close",
    "save": "Save",
    "cancel": "Cancel",
    "manageMenu": "Post actions",
    "share": "Share",
    "loadFailed": "Couldn't load the feed",
    "retry": "Try again"
  },
  "theSpace": {
    "overline": "Features",
    "title": "What's Inside",
    "description": "Designed for modern life. Short and deep sessions led by masters in meditation, breathwork, and psychology.",
    "liveStreams": "Live Sessions",
    "liveStreamsSubtitle": "Live practice, right now.",
    "liveStreamsDesc": "Join sessions happening now or starting soon — guided in real time by world-class masters.",
    "liveStreamsBadge": "Always On · 24/7",
    "liveStreamsAction": "Join live",
    "aiCompanion": "AI Companion",
    "aiCompanionSubtitle": "Private guidance, anytime.",
    "aiCompanionDesc": "Talk it through, set an intention, and get matched to the right practice for your state of mind.",
    "aiCompanionBadge": "Private · On Demand",
    "aiCompanionAction": "Start conversation",
    "agapePractices": "AGAPĒ PRACTICES",
    "agapePracticesSubtitle": "Curated by Agapē.",
    "agapePracticesDesc": "Agapē-approved sessions across meditation, focus, balance, gratitude, and heart work.",
    "agapePracticesBadge": "Curated · Agapē Approved",
    "agapePracticesAction": "Explore practices",
    "communities": "Communities",
    "communitiesSubtitle": "Grow with your people.",
    "communitiesDesc": "Join intention-based groups to stay connected and consistent between sessions.",
    "communitiesBadge": "Community · Member-oriented",
    "communitiesAction": "Discover communities"
  },
  "practices": {
    "title": "Practices",
    "subtitle": "Choose what you need — focus, peace, love, or inner strength.",
    "exploreLibrary": "Explore Full Library",
    "allPractices": "All Practices",
    "meditation": "Meditation",
    "breathwork": "Breathwork",
    "movement": "Movement",
    "meditative": "Meditative Practices",
    "meditativeDesc": "Presence, silence, inner spaciousness to ground your energy.",
    "meditativeTag1": "Deep Calm",
    "meditativeTag2": "Open Awareness",
    "meditativeBadge": "Meditative",
    "neurofocus": "Neurofocus",
    "neurofocusDesc": "Attention, habits, and mental clarity for deep work.",
    "neurofocusTag1": "90-Sec Reset",
    "neurofocusTag2": "Flow State",
    "neurofocusBadge": "Trending",
    "stateDesign": "State Design",
    "stateDesignDesc": "Consciously set your emotional and energetic tone.",
    "stateDesignTag": "Morning Alignment",
    "stateDesignBadge": "Design",
    "somaticBreathwork": "Somatic Breathwork",
    "somaticBreathworkDesc": "Using the breath to release tension stored in the body.",
    "somaticBreathworkTag1": "Release",
    "somaticBreathworkTag2": "Energy",
    "somaticBreathworkBadge": "Body",
    "sleepNonDoing": "Sleep & Non-Doing",
    "sleepNonDoingDesc": "Practices for deep rest, sleep onset, and letting go.",
    "sleepNonDoingTag1": "NSDR",
    "sleepNonDoingTag2": "Yoga Nidra",
    "sleepNonDoingBadge": "Rest",
    "communityCircles": "Community Circles",
    "communityCirclesDesc": "Shared inquiry and holding space for one another.",
    "communityCirclesTag": "Relational",
    "communityCirclesBadge": "Shared"
  },
  "masters": {
    "overline": "Our Masters",
    "title": "Agapēlla — the environment",
    "titleHighlight": "that moves you forward.",
    "description": "Find masters and like-minded people with whom growth becomes natural.",
    "exploreAll": "Explore All Masters",
    "masterBadge": "MASTER",
    "fallbackDesc": "Master"
  },
  "schedule": {
    "title": "Events & Practices.",
    "titleHighlight": "In your rhythm.",
    "subtitle": "From somatic practices to deep retreats — find formats that resonate with your inner state.",
    "today": "Today",
    "withMaster": "with {{name}}",
    "upcomingIntensive": "UPCOMING INTENSIVE"
  },
  "scheduleCalendar": {
    "eventsThisMonth": "{{count}} event this month",
    "eventsThisMonth_plural": "{{count}} events this month",
    "selectDate": "Select a Date",
    "eventCount": "{{count}} event",
    "eventCount_plural": "{{count}} events",
    "noEvents": "No events scheduled",
    "noEventsHint": "Select another date or browse a different month",
    "reminded": "Reminded",
    "remindMe": "Remind Me"
  },
  "aboutPlatformWidget": {
    "title": "Want to learn about our platform's features?",
    "description": "Agapēlla is a space for practices, conscious meetings, and live interaction between masters and participants.",
    "cta": "Learn more"
  },
  "circlesPreview": {
    "overline": "Community",
    "title": "Find Your Tribe",
    "subtitle": "Connect with people who share your practices and philosophy.",
    "exploreAll": "Explore All",
    "members": "members"
  },
  "native": {
    "tabs": {
      "home": "Home",
      "events": "Events",
      "practices": "Practices",
      "masterFeed": "Master\nfeed",
      "liveSession": "Live\nsession",
      "messages": "Messages",
      "profile": "Profile"
    },
    "heroFallback": {
      "title": "A human-centered platform for knowledge and practice",
      "subtitle": "Agapella brings together trusted masters, live practices and supportive community so people can grow with steadiness and care."
    },
    "heroArt": {
      "dark": "Sunset over a lake, mountains",
      "light": "Sunrise over a lake, mountains"
    },
    "closing": {
      "lead": "Your practice. ",
      "accent": "Every day."
    },
    "openPractice": {
      "label": "OPEN PRACTICE",
      "title": "Agapē practice",
      "description": "15 minutes that bring you back to yourself. Silence, clarity and a full reset.",
      "want": "Join",
      "invite": "Invite friends"
    },
    "capabilitiesLead": "Agapella ",
    "capabilities": {
      "createRoom": {
        "title": "Create\nyour live session",
        "description": "Pick a practice, invite friends — and practise together in real time."
      },
      "masters": {
        "title": "Find\nyour master",
        "description": "Experts in meditation and psychology — your personal guide."
      },
      "calendar": {
        "title": "Practice\ncalendar",
        "description": "Online and offline events every day."
      },
      "assistant": {
        "title": "AI assistant",
        "description": "A warm companion at any moment of the day."
      },
      "library": {
        "title": "Your\nlibrary",
        "description": "Favourite practices and recordings at hand."
      },
      "center": {
        "title": "Agapē\ncenter",
        "description": "A community that supports your evolution."
      }
    },
    "sections": {
      "capabilities": "Features",
      "liveNow": "Live sessions happening now",
      "upcomingEvents": "Upcoming events",
      "featuredMasters": "Masters nearby",
      "newMasters": "New masters",
      "upcomingFallback": "Upcoming events",
      "newMedia": "New media",
      "news": "Agapella news"
    },
    "seeAll": "SEE ALL",
    "seeAllShort": "All →",
    "join": "Join",
    "audio": "Audio",
    "online": "Online",
    "offline": "Offline",
    "calendarChips": {
      "directions": "Directions",
      "live": "Live session",
      "offline": "Offline"
    },
    "inviteMessage": "Join a practice on Agapella — 15 minutes of silence that bring you back to yourself.",
    "pathInvite": {
      "title": "Follow your path with Agapella",
      "body": "Practices and support at your own pace.",
      "cta": "Start the path"
    },
    "masters": {
      "follow": "Follow",
      "following": "Following",
      "share": "Share profile",
      "followError": "Could not update the subscription"
    },
    "seeAllLink": "See all",
    "upcoming": {
      "subtitle": "Live, online and offline meetings coming soon.",
      "rsvp": "RSVP",
      "open": "Open",
      "going": "Going",
      "unavailable": "Unavailable",
      "error": "Could not update RSVP. Please try again."
    },
    "directions": {
      "title": "Who or what would I like to care for today?",
      "items": {
        "self": "Discover who I am",
        "calm": "Overcome anxiety and insomnia",
        "morning": "Begin my day resourced",
        "health": "Choose to care for my health",
        "close": "Understand myself and those close to me better",
        "support": "Find support"
      }
    },
    "roulette": {
      "random": "Not sure where to begin",
      "caption": "Random choice",
      "spinning": "Choosing a direction…",
      "result": "Selected direction",
      "selected": "Selected",
      "open": "Open direction"
    },
    "infoCards": {
      "assistantTitle": "Ask Agapella",
      "assistantAction": "Start a conversation",
      "platformTitle": "How the platform works",
      "platformAction": "Learn more"
    },
    "news": {
      "read": "Read",
      "open": "Open",
      "all": "All materials",
      "back": "Back",
      "close": "Close",
      "empty": "No news has been published yet."
    }
  }
}
